<app-header [enableBack]="true">
</app-header>
<div class="p-6">
  <app-table
    #table
    [config]="tableConfig"
    [(selectedElements)]="selectedElements">
  </app-table>
</div>
